export const START_SEARCH_REQUEST = 'START_SEARCH_REQUEST';
export const START_SEARCH_SUCCESS = 'START_SEARCH_SUCCESS';
export const START_SEARCH_FAILURE = 'START_SEARCH_FAILURE';

export const FETCH_SEARCH_REQUEST = 'FETCH_SEARCH_REQUEST';
export const FETCH_SEARCH_SUCCESS = 'FETCH_SEARCH_SUCCESS';
export const FETCH_SEARCH_FAILURE = 'FETCH_SEARCH_FAILURE';

export const PING_SEARCH_REQUEST = 'CANCEL_PING_REQUEST';
export const PING_SEARCH_SUCCESS = 'CANCEL_PING_SUCCESS';
export const PING_SEARCH_FAILURE = 'CANCEL_PING_FAILURE';

export const CANCEL_SEARCH_REQUEST = 'CANCEL_SEARCH_REQUEST';
export const CANCEL_SEARCH_SUCCESS = 'CANCEL_SEARCH_SUCCESS';
export const CANCEL_SEARCH_FAILURE = 'CANCEL_SEARCH_FAILURE';

export const FETCH_SEARCHES_REQUEST = 'FETCH_SEARCHES_REQUEST';
export const FETCH_SEARCHES_SUCCESS = 'FETCH_SEARCHES_SUCCESS';
export const FETCH_SEARCHES_FAILURE = 'FETCH_SEARCHES_FAILURE';

export const EXPORT_SEARCH_REQUEST = 'EXPORT_SEARCH_REQUEST';
export const EXPORT_SEARCH_SUCCESS = 'EXPORT_SEARCH_SUCCESS';
export const EXPORT_SEARCH_FAILURE = 'EXPORT_SEARCH_FAILURE';